import styled from 'styled-components'

const LogoText = styled.h2`
    font-size: 1.45rem;
    text-transform: uppercase;
    color: hsl(242, 100%, 66%);
    font-weight: 700;
`

export default LogoText